import React from 'react'
import FuelOpView from './FuelOpView'

function FuelGeneralView() {
  return (
    <FuelOpView />
  )
}

export default FuelGeneralView